import React, { useEffect, useState } from "react";
import { View } from "react-native";
import commonStyles from "../../../styles/commonStyles";
import OverflowTooltipText from "../../../components/OverflowTooltipText";
import { ScrollView } from "react-native-gesture-handler";
import AppText from "../../../components/AppText";

interface BankDetailsView {
  userData: any; 
}

const BankDetailsView: React.FC<BankDetailsView> = ({ userData }) => {
  useEffect(() => {
    console.log("User data for Address View:", userData);
  }, []);

  return (
    <ScrollView>
      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>Bank Name</AppText>
        <OverflowTooltipText
        testID="bank-name"
          text={userData?.bankDetail?.bankName || ""}
          style={commonStyles.subValue}
          containerWidth="40%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>Account Number</AppText>
        <OverflowTooltipText
        testID="account-number"
          text={userData?.bankDetail?.accountNumber || ""}
          style={commonStyles.subValue}
          containerWidth="40%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>Wire Routing Number</AppText>
        <OverflowTooltipText
        testID="wire-routing-number"
          text={userData?.bankDetail?.wireRoutingNumber || ""}
          style={commonStyles.subValue}
          containerWidth="40%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>ACH Routing Number</AppText>
        <OverflowTooltipText
        testID="ach-routing-number"
          text={userData?.bankDetail?.achRoutingNumber || ""}
          style={commonStyles.subValue}
          containerWidth="40%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>Zelle ID</AppText>
        <OverflowTooltipText
        testID="zelle-id"
          text={userData?.bankDetail?.zelleId || ""}
          style={commonStyles.subValue}
          containerWidth="40%"
        />
      </View>

      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>Address 1</AppText>
        <OverflowTooltipText
        testID="address1"
          text={userData?.bankDetail?.address?.street1 || ""}
          style={commonStyles.subValue}
          containerWidth="40%"
        />
      </View>

      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>Address 2</AppText>
        <OverflowTooltipText
        testID="address2"
          text={userData?.bankDetail?.address?.street2 || ""}
          style={commonStyles.subValue}
          containerWidth="40%"
        />
      </View>

      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>City</AppText>
        <OverflowTooltipText
        testID="city"
          text={userData?.bankDetail?.address?.city || ""}
          style={commonStyles.subValue}
          containerWidth="40%"
        />
      </View>

      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>State</AppText>
        <OverflowTooltipText
         testID="state"
          text={userData?.bankDetail?.address?.state || ""}
          style={commonStyles.subValue}
          containerWidth="40%"
        />
      </View>

      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>Zip Code</AppText>
        <OverflowTooltipText
        testID="zip-code"
          text={userData?.bankDetail?.address?.zipCode || ""}
          style={commonStyles.subValue}
          containerWidth="40%"
        />
      </View>
    </ScrollView>
  );
};

export default BankDetailsView;
